import makeStyles from '@mui/styles/makeStyles';

import {Link} from 'react-router-dom';

import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { memo } from "react";
import BasicButton from "./Buttons/BasicButton";

const useStyles = makeStyles(theme =>({
    root: {
        color: theme.palette.secondary.muted2,
        //fontWeight: theme.typography.fontWeightRegular,
        padding: theme.spacing(2),
        '&:hover': {
            borderColor: theme.palette.primary.light,
            color: theme.palette.primary.light
        },
        '&:active':{
            borderColor: '#fff',
            color: '#fff',
        },
        '& .MuiButton-startIcon': {
            marginRight: theme.spacing(1)
        }
    },
    rootResponsive: {
        "& .backlink__label" : {
            [theme.breakpoints.down('sm')]: {
                display: "none",
            },
        },
    },
}));

function BackLink({ className = "", ...props }) {
    const classes = useStyles();
    return(
        <>
            <BasicButton
                color='secondary'
                className={className + " " + classes.root + " " + classes.rootResponsive}
                startIcon={KeyboardBackspaceIcon}
                component={Link}
                {...props}
            >
                <span className="backlink__label">BACK</span>
            </BasicButton>
        </>
    );
}

export default memo(BackLink);